import { render } from "./TitleField.vue?vue&type=template&id=04bf47b1"
import script from "./TitleField.vue?vue&type=script&lang=js"
export * from "./TitleField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__